import { gql } from '@apollo/client';

export const IS_EMQ_ENABLED_QUERY = gql`
  query IsEmqEnabled {
    merchant {
      emqScoreEnabled
    }
  }
`;
